import { useNavigate } from "react-router-dom";
import { AgGridReact } from "ag-grid-react";
import {
  ModuleRegistry,
  InfiniteRowModelModule,
} from "ag-grid-community";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { useState, useMemo, useCallback } from "react";
import CustomHeader from "../../CustomHeader";
import ActionCellBilling from "../Utility/ActionCellBilling";

ModuleRegistry.registerModules([InfiniteRowModelModule]);

function CustomerSalesTable({
  // keeping original props signature for drop-in compatibility
  getPatients,
  isFetching,
  isLoading,
  isSuccess,
  gridRef,
  openCanvas,
  selectedFilters,
  hasData,
  setHasData,
}) {
  const navigate = useNavigate();

  const getStableColor = (key) => {
    const bgColors = [
      "bg-danger bg-opacity-50",
      "bg-success bg-opacity-50",
      "bg-primary bg-opacity-50",
      "bg-warning bg-opacity-50",
      "bg-secondary bg-opacity-50",
      "bg-danger bg-opacity-50",
      "bg-primary bg-opacity-50",
      "bg-info bg-opacity-50",
      "bg-warning bg-opacity-50",
      "bg-success bg-opacity-50",
      "bg-info bg-opacity-10",
      "bg-success bg-opacity-50",
      "bg-danger bg-opacity-50",
      "bg-danger bg-opacity-50",
      "bg-secondary bg-opacity-50",
    ];
    let hash = 0;
    for (let i = 0; i < key.length; i++) {
      hash = key.charCodeAt(i) + ((hash << 5) - hash);
    }
    const index = Math.abs(hash) % bgColors.length;
    return bgColors[index];
  };

  // 10 static demo rows (based on provided shape)
  const staticRows = useMemo(
    () => [ {
      customerName: "Aarav Sharma",
    patientName: "Aarav Sharma",
    patientID: "P-1001",
    invoiceID: "INV-45321",
    gender: "Male",
    age: 32,
    doctor: "Dr. Mehta",
    totalAmount: "₹2,350",
    txnDate: "2025-10-05",
    paymentMethod: "Paid",
    phoneNumber: "+91 98765 43210",
  },
  {
    customerName: "Priya Nair",
    patientName: "Diya Patel",
    patientID: "P-1002",
    invoiceID: "INV-45322",
    gender: "Female",
    age: 27,
    doctor: "Dr. Kapoor",
    totalAmount: "₹4,100",
    txnDate: "2025-10-06",
    paymentMethod: "Paid",
    phoneNumber: "+91 98234 67109",
  },
  {
    customerName: "Aarav Sharma",
    patientName: "Rohan Verma",
    patientID: "P-1003",
    invoiceID: "INV-45323",
    gender: "Male",
    age: 41,
    doctor: "Dr. Bhatia",
    totalAmount: "₹1,850",
    txnDate: "2025-10-06",
    paymentMethod: "Due",
    phoneNumber: "+91 98456 12340",
  },
  {
    customerName: "Karan Singh",
    patientName: "Priya Nair",
    patientID: "P-1004",
    invoiceID: "INV-45324",
    gender: "Female",
    age: 36,
    doctor: "Dr. Iyer",
    totalAmount: "₹3,200",
    txnDate: "2025-10-07",
    paymentMethod: "Paid",
    phoneNumber: "+91 98123 67542",
  },
  {
    customerName: "Diya Patel",
    patientName: "Karan Singh",
    patientID: "P-1005",
    invoiceID: "INV-45325",
    gender: "Male",
    age: 29,
    doctor: "Dr. Malhotra",
    totalAmount: "₹2,700",
    txnDate: "2025-10-07",
    paymentMethod: "Paid",
    phoneNumber: "+91 99567 81234",
  },
  {
    customerName: "Rahul Chatterjee",
    patientName: "Sneha Reddy",
    patientID: "P-1006",
    invoiceID: "INV-45326",
    gender: "Female",
    age: 34,
    doctor: "Dr. Menon",
    totalAmount: "₹5,450",
    txnDate: "2025-10-08",
    paymentMethod: "Paid",
    phoneNumber: "+91 98770 11445",
  },
  {
    customerName: "Aarav Sharma",
    patientName: "Aditya Kumar",
    patientID: "P-1007",
    invoiceID: "INV-45327",
    gender: "Male",
    age: 40,
    doctor: "Dr. Mehta",
    totalAmount: "₹3,900",
    txnDate: "2025-10-08",
    paymentMethod: "Due",
    phoneNumber: "+91 98122 44356",
  },
  {
    customerName: "Isha Gupta",
    patientName: "Ananya Das",
    patientID: "P-1008",
    invoiceID: "INV-45328",
    gender: "Female",
    age: 30,
    doctor: "Dr. Banerjee",
    totalAmount: "₹2,150",
    txnDate: "2025-10-09",
    paymentMethod: "Paid",
    phoneNumber: "+91 98345 78901",
  },
  {
    customerName: "Sneha Reddy",
    patientName: "Rahul Chatterjee",
    patientID: "P-1009",
    invoiceID: "INV-45329",
    gender: "Male",
    age: 38,
    doctor: "Dr. Sinha",
    totalAmount: "₹4,250",
    txnDate: "2025-10-09",
    paymentMethod: "Due",
    phoneNumber: "+91 98453 66543",
  },
  {
    customerName: "Aarav Sharma",
    patientName: "Isha Gupta",
    patientID: "P-1010",
    invoiceID: "INV-45330",
    gender: "Female",
    age: 26,
    doctor: "Dr. Khanna",
    totalAmount: "₹3,050",
    txnDate: "2025-10-10",
    paymentMethod: "Due",
    phoneNumber: "+91 98876 99012",
  },
],
    []
  );

  const onGridReady = useCallback((params) => {
    const dataSource = {
      rowCount: undefined,
      getRows: (getRowsParams) => {
        const { startRow, endRow } = getRowsParams;
        const rowsThisPage = staticRows.slice(startRow, endRow);
        const lastRow =
          endRow >= staticRows.length ? staticRows.length : -1;

        if (typeof setHasData === "function") {
          setHasData(staticRows.length > 0);
        }

        getRowsParams.successCallback(rowsThisPage, lastRow);
      },
    };

    params.api.setGridOption("datasource", dataSource);
  }, [setHasData, staticRows]);

  const [colDefs] = useState([
        {
      headerName: "Patient",
      field: "customerName",
      width: 170,
      minWidth: 170,
      suppressSizeToFit: true,
      sortable: true,
      filter: true,
      cellRenderer: function (params) {
        if (params.value !== undefined) {
          const name = params.value || "U";
          const initial = name.charAt(0).toUpperCase();
          const bgColor = getStableColor(name);
          return (
            <div className="d-flex align-items-center gap-2">
              <div
                className={`d-flex justify-content-center align-items-center rounded-circle text-white fw-bold ${bgColor}`}
                style={{ width: "2rem", height: "2rem", fontSize: "0.875rem" }}
              >
                {initial}
              </div>
              <span className="fw-bold text-secondary small">{name}</span>
            </div>
          );
        }
      },
    },
    {
      headerName: "Invoice ID",
      field: "invoiceID",
      minWidth: 150,
      suppressSizeToFit: true,
      sortable: true,
      filter: true,
      cellRenderer: (params) => {
        if (params.value !== undefined) {
          return (
            <span className="text-secondary fw-medium small">{params.value}</span>
          );
        }
      },
    },
    {
      headerName: "Gender",
      field: "gender",
      minWidth: 120,
      suppressSizeToFit: true,
      sortable: true,
      filter: true,
      cellRenderer: (params) => {
        if (params.value !== undefined) {
          return (
            <span className="text-secondary fw-medium small">{params.value}</span>
          );
        }
      },
    },
    {
      headerName: "Age",
      field: "age",
      minWidth: 80,
      suppressSizeToFit: true,
      sortable: true,
      filter: true,
      cellRenderer: (params) => {
        if (params.value !== undefined) {
          return (
            <span className="text-secondary fw-medium small">{params.value}</span>
          );
        }
      },
    },
    {
      headerName: "Doctor",
      field: "doctor",
      minWidth: 150,
      suppressSizeToFit: true,
      sortable: true,
      filter: true,
      cellRenderer: (params) => {
        if (params.value !== undefined) {
          return (
            <span className="text-secondary fw-medium small">{params.value}</span>
          );
        }
      },
    },
    {
      headerName: "Invoice Amount",
      field: "totalAmount",
      minWidth: 140,
      suppressSizeToFit: true,
      sortable: true,
      filter: true,
      cellRenderer: (params) => {
        if (params.value !== undefined) {
          return (
            <span className="text-secondary fw-medium small">{params.value}</span>
          );
        }
      },
    },
    {
      headerName: "Invoice Date",
      field: "txnDate",
      minWidth: 140,
      suppressSizeToFit: true,
      sortable: true,
      filter: true,
      cellRenderer: (params) => {
  if (params.value !== undefined) {
    const date = new Date(params.value);

    // Format the date as 20-Dec-2025
    const day = date.getDate().toString().padStart(2, "0");
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();
    const formattedDate = `${day}-${month}-${year}`;

    return (
      <span className="text-secondary fw-medium small">
        {formattedDate}
      </span>
    );
  }
},
    },
   {
  headerName: "Payment",
  field: "paymentMethod",
  minWidth: 150,
  suppressSizeToFit: true,
  sortable: true,
  filter: true,
  cellStyle: {
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
  },
  cellRenderer: (params) => {
    if (!params.value) return "";

    const value = params.value.toString().trim().toLowerCase();

    // Apply your custom palette
    let colors = { background: "#6c757d", border: "#6c757d" }; // default grey

    if (value === "paid") {
      colors = { background: "#198754", border: "#198754" }; // green
    } else if (value === "due") {
      colors = { background: "#ffc107", border: "#ffc107" }; // yellow
    }

    return (
      <div
        style={{
          background: colors.background,
          border: `1px solid ${colors.border}`,
          color: "#fff",
          padding: "4px 10px",
          borderRadius: "999px",
          fontSize: "12px",
          fontWeight: 600,
          minWidth: "80px",
          textAlign: "center",
          lineHeight: "1rem",
        }}
      >
        {params.value}
      </div>
    );
  },
},
    {
      headerName: "Action",
      field: "",
      minWidth: 150,
      suppressSizeToFit: true,
      resizable: false,
      cellStyle: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      },
      cellRenderer: (params) => {
        if (params.data !== undefined) {
         return <ActionCellBilling data={params.data} openCanvas={openCanvas} />
        }
      },
    },
  ]);

  const autoSizeStrategy = {
    type: "fitGridWidth",
    columnLimits: [
      {
        colId: "No of Team Members",
        minWidth: 900,
      },
    ],
  };

  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      filter: true,
      sortable: true,
      enableRowGroup: true,
      sort: "asc",
      resizable: true,
      headerComponent: CustomHeader,
    };
  }, []);

    const tableStyle = `

  .btn-IdWmkZEQJd {
  border: none;
    background: none;
    color: #035ecf;
    width: 2.4rem;
    height: 2.4rem;
    display: flex
;
    align-items: center;
    justify-content: center;
    border-radius: .245rem;
    padding: .25rem .5rem;
  }


.ag-horizontal-right-spacer.ag-scroller-corner {
    display: none !important;
}

.ag-header-viewport {
  overflow-x: hidden !important;
  will-change: auto !important;
}

/* Soothing green strip for selected row */
.ag-theme-quartz .ag-row-selected::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background-color: #77c658; /* strip stays green */
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  z-index: 1;
}

.ag-cell-value{
  border-left: unset !important;
  border-right: 1px solid #e5e5e5 !important;
}

.ag-column-first{
  border: unset !important;
}

.ag-theme-quartz .ag-row-selected::after {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background-color: #77c658; /* strip stays green */
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  z-index: 1;
}

/* Override hover background for selected rows */
.ag-theme-quartz .ag-row-hover .ag-row-selected:hover {
  background-color: #f4fbf1 !important; /* same as selected */
}

.ag-checkbox-input-wrapper::before{
  display: none;
}

.ag-checkbox-input-wrapper::after{
  display: none;
}

  .ag-ltr .ag-sort-indicator-icon {
    padding-left: var(--ag-grid-size);
    display: none;
}

  .ag-header, .ag-advanced-filter-header {
    // background-color: #ff525a;
      background-color: #203342;
    border-bottom: var(--ag-borders-critical) var(--ag-border-color);
}

            .ag-full-width-container{
            height : 100% !important;
          }


         

  
        .ag-header-cell-text {
        font-size: 0.9rem;
      text-transform: uppercase;
      color: #1e374f;
      font-weight: 600;
      font-family: 'Nunito', sans-serif !important;

        }

              .ag-header-cell-resize::after{
                      background-color: #1991eb52;
                  }


            .ag-theme-quartz{
            padding: 0.4rem;
            }

              .ag-ltr .ag-cell{

                      text-align: center;
                      display: flex;
                      // justify-content: center;
                      align-items: center;
              }

              .ag-header{
                  // background-color: #edeff6;
                   border: none;
                  padding: 0.5rem 0;

                  min-height: 44px !important;
                  font-family: 'Nunito', sans-serif !important;
              }

              .ag-row {
               border: 1px solid #eeedf0;

              }

                  .ag-row-odd {
    background-color: #fff !important; /* Light gray */
  }

                    .ag-row-even {
    background-color: #f7f7f7 !important; /* Light gray */
  }






              .ag-root-wrapper{
                border: unset;
                background: transparent
              }

              .ag-body-viewport{
                border: 1px solid #8080801a;
                border-top-left-radius: 5px !important;
                border-top-right-radius: 5px !important;
                background-color: white;
              }

              .ag-theme-quartz .ag-header-cell-filter-button{
              display: none;}

.ag-header-cell-resize:after {
    background-color: #1991eb52;
    content: "";
    display: block;
    height: 30%;
    position: absolute;
    top: calc(50% - 30% * .5);2px;
    z-index: 1;
}

               .ag-cell, .ag-cell-not-inline-editing, .ag-cell-normal-height, .ag-cell-value, .ag-cell-focus{
                  font-size: .9rem;
               }

        .ag-body-vertical-scroll{
            display : none;
          }

    .ag-header-cell-sortable .ag-header-cell-label{
           justify-content: start;
        }
        
        .ag-ltr .ag-cell {
            font-weight: 500 !important;
            letter-spacing: 0.5px;
            color: #2b2b2b !important;
        }


          .odd-row {
          background-color: #f8f8fc;
        }
        
        .span-saceuu7u7{
            font-size: 13px; 
            background-color: #FAAB3C; 
            padding: .8rem .5rem;
            border-radius: 10rem;
            height:1rem;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        
        .span-jkmkmkmkm{
            font-size: 10px; 
            color: #6941C6 ;
            border: solid .1px #6941C6; 
            background-color: #F9F5FF; 
            padding: .8rem .5rem;
            border-radius: 10rem;
            width: 7rem;
            height:1rem;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        
        .span-jkmkmkmkmjbui{
            font-size: 10px; 
            color: #175CD3 ;
            border: solid .1px #B2DDFF; 
            background-color: #EFF8FF; 
            padding: .8rem .5rem;
            border-radius: 10rem;
            width: 7rem;
            height:1rem;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        
                .ag-header-cell-label{
        display: flex;
        justify-content: center;
        }
         .ag-cell:focus,
  .ag-cell-focus,
  .ag-row-focus {
    outline: none !important;
    border: none !important;
    box-shadow: none !important;
  }

        
        
  
  `;

  let content = null;

  if (!hasData) {
    content = (
      <div className="flex flex-col justify-center items-center h-[30rem]">
        <img
          src="/Images/doctortable.png"
          alt="No Patients"
          className="w-[400px] mb-4"
        />
        <p className="text-muted text-sm">No Patients Available</p>
      </div>
    );
  } else {
    content = (
      <div
        id="grid-wrapper"
        className="ag-theme-quartz custom-ag-grid"
        style={{
          width: "100%",
          height: "100%",
          backgroundColor: "#fff",
          minHeight: "32rem",
        }}
      >
        <style>{tableStyle}</style>
        <AgGridReact
          ref={gridRef}
          columnDefs={colDefs}
          defaultColDef={defaultColDef}
          rowHeight={40}
          headerHeight={30}
          rowBuffer={0}
          rowModelType={"infinite"}
          cacheBlockSize={100}
          cacheOverflowSize={5}
          maxConcurrentDatasourceRequests={1}
          maxBlocksInCache={10}
          animateRows={true}
          onGridReady={onGridReady}
        />
      </div>
    );
  }

  return <div style={{ width: "100%", height: "89%" }}>{content}</div>;
}

export default CustomerSalesTable;
